
export enum StsRegistrationType {
  Registration = 0,
  ForgotUserName = 1,
  ResetCredentials = 2
}

// without this dummy class you can't export this enum (Typescript bug)
export default class StsRegistrationEnums {
}

